import { render, staticRenderFns } from "./zTeam.vue?vue&type=template&id=388daaf0&scoped=true"
import script from "./zTeam.vue?vue&type=script&lang=js"
export * from "./zTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388daaf0",
  null
  
)

export default component.exports